module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events-requests"
  }, [_c('div', {
    staticClass: "cities"
  }, _vm._l((_vm.eventCities), function(place) {
    return _c('span', {
      staticClass: "city-wrapper",
      on: {
        "click": function($event) {
          return _vm.handleGetEventCity(place.id)
        }
      }
    }, [_c('span', {
      key: place.id,
      staticClass: "city-title",
      class: _vm.selectedCity && _vm.selectedCity.id === place.id ? 'is-active' : ''
    }, [_vm._v(_vm._s(place.name) + "\n      ")])])
  }), 0), _vm._v(" "), (_vm.selectedCity) ? _c('div', {
    staticClass: "events columns is-multiline"
  }, _vm._l((_vm.selectedCity.events), function(event) {
    return _c('div', {
      key: event.id,
      staticClass: "event-wrapper column is-half"
    }, [_c('div', {
      staticClass: "event centered"
    }, [(event.eventParticipants.length) ? _c('span', {
      ref: "event.id",
      refInFor: true,
      staticClass: "link",
      attrs: {
        "id": event.id
      },
      on: {
        "click": _vm.showParticipants
      }
    }, [_vm._v("\n          Посмотреть " + _vm._s(event.eventParticipants.length) + " зарегистровавшихся\n        ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("filterDate")(event.date)) + " "), _c('br')]), _vm._v(" "), _c('span', {
      staticClass: "event-title"
    }, [_vm._v(_vm._s(event.title) + " "), _c('br')]), _vm._v(" "), _c('span', [_vm._v(_vm._s(event.description) + " "), _c('br')])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.event) ? _c('el-dialog', {
    staticClass: "event-dialog",
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "event-participants"
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.event.title) + "\n      ")]), _vm._v(" "), _c('span', [_vm._v("\n        " + _vm._s(_vm.event.date) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "event-participants-count"
  }, [_vm._v("\n        " + _vm._s(_vm.event.eventParticipants.length) + "\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "participants-table"
  }, _vm._l((_vm.event.eventParticipants), function(participant) {
    return _c('tr', [_c('td', {
      staticClass: "name"
    }, [_vm._v(" " + _vm._s(participant.surname) + " "), _c('br'), _vm._v(" " + _vm._s(participant.name) + " " + _vm._s(participant.patronymic))]), _vm._v(" "), _c('td', {
      staticClass: "commpany-name"
    }, [_vm._v(" " + _vm._s(participant.companyName))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(participant.phone))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(participant.email))])])
  }), 0)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34590781"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/EventsRequests.vue
// module id = 926
// module chunks = 0